import React, { useEffect, useState } from "react";

function Leaderboard() {
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchLeaderboard() {
      try {
        const response = await fetch("https://leaderboard-worker.tylergrantguy.workers.dev/api/leaderboard");
        const data = await response.json();
        setLeaderboardData(data);
      } catch (error) {
        console.error("Error fetching leaderboard data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchLeaderboard();
  }, []);

  if (loading) {
    return <div>Loading leaderboard...</div>;
  }

  const currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const formatChange = (value) => {
    if (value === 0) {
      return <span>-</span>; // Display a hyphen for zero values
    }
    const badgeClass = value > 0 ? "badge-positive" : "badge-negative";
    // return <span className={`badge ${badgeClass}`}>$ {value.toFixed(2)}</span>;
    return <span>+ {currencyFormatter.format(value)}</span>;
  };

  return (
    <div className="leaderboard-container">
      <h1>Leaderboard</h1>
      <table className="leaderboard-table">
        <thead>
          <tr>
            <th>Rank</th>
            <th>UID</th>
            <th>Latest Weighted Wagered</th>
            <th>Change (30 Min)</th>
            <th>Change (1 Hour)</th>
            <th>Change (3 Hours)</th>
            <th>Change (12 Hours)</th>
            <th>Change (24 Hours)</th>
            <th>Change (72 Hours)</th>
          </tr>
        </thead>
        <tbody>
          {leaderboardData.map((user) => (
            <tr key={user.uid}>
              <td>{user.rank}</td>
              <td>{user.uid}</td>
              <td className="highlight">{currencyFormatter.format(user.latestWeightedWagered)}</td>
              <td>{formatChange(user.difference30Min)}</td>
              <td>{formatChange(user.difference1Hour)}</td>
              <td>{formatChange(user.difference3Hour)}</td>
              <td>{formatChange(user.difference12Hour)}</td>
              <td>{formatChange(user.difference24Hour)}</td>
              <td>{formatChange(user.difference72Hour)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Leaderboard;
